const styles = (theme) => ({
  root: {},
  avatar: {
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
    color: theme.palette.custom.accounts,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  invalidAccount: {
    borderColor: '#CE2C29',
    borderWidth: '2px',
  },
});

export default styles;
